import { QuoteRequest, QuoteResponse } from './quote-domain';

export abstract class QuoteRepository {
  abstract createQuote(params: QuoteRequest): Promise<QuoteResponse>;
}
